import { Component } from '@angular/core';
import { NavController,NavParams,AlertController,LoadingController } from 'ionic-angular';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import { HomePage } from '../home/home';
import { Params } from '../params';
import { Events } from 'ionic-angular';
import { Http } from '@angular/http';
import { DaysPage } from '../days/days';


@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl : AlertController,
    public events: Events,
    public loadingCtrl : LoadingController,
    public http: Http
  ) {
    let loading = this.loadingCtrl.create({
      content : "Espere porfavor"
    })
    loading.present();
    let logout = this.navParams.get('logout');
    if(logout) {
      firebase.auth().signOut();
      return;
    }
    let version = "";
    this.http.get('assets/json/v.json').subscribe((r)=>{
      version = r.json().version;
    })

    firebase.auth().onAuthStateChanged((user) => {
      console.log("Cambia estado de auth", user);
      if (!user) {
        loading.dismiss();
        return;
      } else {
        const body = {
          name: user.displayName,
          email: user.email,
          uid: user.uid,
          photo: user.photoURL,
          role: '',
          app: version
        };

        this.http.post('https://admin.fitfood.cl/checkUser', body).subscribe((j) => {
          let r = j.json();
          if (r['start']) {
            Params.USER_DATA.uid = body.uid;
            Params.USER_DATA.name = body.name;
            Params.USER_DATA.email = body.email;
            Params.USER_DATA.photo = body.photo;
            Params.USER_DATA.roles = r['role'];
            loading.dismiss();
            this.events.publish('user:loggedin');
            navCtrl.setRoot(HomePage);
          } else {
            loading.dismiss();
            let alert = this.alertCtrl.create({
              title: 'Cuenta inactiva',
              message: 'Debe esperar que un administrador active su cuenta',
              buttons: [
                {
                  text: 'Comprendo',
                  role: 'cancel'
                }
              ]
            });
            alert.present();
          }
        }, error => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: 'Problema',
            message: error.message,
            buttons: [
              {
                text: 'Comprendo',
                role: 'cancel'
              }
            ]
          });
          alert.present();
        })

        // create oncall firebase function
        // firebase.functions().httpsCallable('checkUser')(body).then((result) => {
        //   const r = result.data;
        //   if (r['start']) {
        //     Params.USER_DATA.uid = body.uid;
        //     Params.USER_DATA.name = body.name;
        //     Params.USER_DATA.email = body.email;
        //     Params.USER_DATA.photo = body.photo;
        //     Params.USER_DATA.roles = r['role'];
        //     loading.dismiss();
        //     this.events.publish('user:loggedin');
        //     navCtrl.setRoot(HomePage);
        //   } else {
        //     loading.dismiss();
        //     let alert = this.alertCtrl.create({
        //       title: 'Cuenta inactiva',
        //       message: 'Debe esperar que un administrador active su cuenta',
        //       buttons: [
        //         {
        //           text: 'Comprendo',
        //           role: 'cancel'
        //         }
        //       ]
        //     });
        //     alert.present();
        //   }
        // }).catch((err) => {
        //   console.log('err', err);
        //   loading.dismiss();
        //   let alert = this.alertCtrl.create({
        //     title: 'Problema',
        //     message: err.message,
        //     buttons: [
        //       {
        //         text: 'Comprendo',
        //         role: 'cancel'
        //       }
        //     ]
        //   });
        //   alert.present();
        // })
      }
    });
  }

  login() {
      firebase.auth()
      .signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .then(res => {console.log("login",res)});
  }


}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts